import { Indicator } from '../../../Common/Charts/Indicator';
import { useFetalDeathChartsDataContext } from './hooks/useFetalDeathChartsDataContext';

export const FetalDeaths = () => {
    const { chartData } = useFetalDeathChartsDataContext();

    return (
        <Indicator
            title={'Indice de Obitos Fetais'}
            indicatorValue={chartData?.indicators?.fetalDeaths}
        />
    );
};
